import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flow } from 'signup-constants/Flow';
import { Button } from 'foundations-components/transitional/components/Button';
import { useSignupContext } from '../../../hooks/useSignupContext';
import { getQueryParams } from '../../../utils/queryParams';
import { generateSignupUrlWithQueryParams, getHubsSignupUrl } from '../../../utils/signupUrl';
import { ErrorBoundary, ErrorBoundaryNames } from '../../ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
const PRODUCT_LINE_TO_SIGNUP_FLOW = {
  MARKETING: Flow.Marketing,
  SALES: Flow.Sales,
  SERVICE: Flow.Service,
  CMS: Flow.CmsFree,
  COMMERCE: Flow.Commerce
};
const getSignupFlowFromProductLine = productLine => {
  if (!productLine) {
    return Flow.Crm;
  }
  return PRODUCT_LINE_TO_SIGNUP_FLOW[productLine] || Flow.Crm;
};
const SignupButtonBase = props => {
  const {
    'data-test-id': dataTestId,
    'data-selenium-id': dataSeleniumId,
    apiName,
    children,
    uiButtonProps,
    onClick,
    eligibleTreatments,
    trackingData
  } = props;
  const {
    hubsSignupUrl,
    hubsSignupCta,
    productLine
  } = useSignupContext({
    apiName,
    ctaType: 'signup',
    trackingData
  });
  const signupType = useMemo(() => getSignupFlowFromProductLine(productLine), [productLine]);
  const isHsoc = useMemo(() => {
    const params = getQueryParams();
    const raw = params.isHsoc;
    if (raw === undefined || raw === null) return undefined;
    return String(raw);
  }, []);
  const signupUrl = useMemo(() => {
    if (!hubsSignupCta) {
      return null;
    }
    return generateSignupUrlWithQueryParams({
      signupType,
      queryParams: {
        hubsSignupCta,
        hubsSignupUrl: hubsSignupUrl || getHubsSignupUrl(),
        domainWithoutHttps: window.location.hostname.replace(/^https?:\/\//, ''),
        pathname: window.location.pathname,
        uuid: window.__utAnonId || '',
        isHsoc
      },
      experiments: eligibleTreatments
    });
  }, [signupType, hubsSignupCta, hubsSignupUrl, eligibleTreatments, isHsoc]);
  const handleClick = () => {
    onClick === null || onClick === void 0 || onClick();
  };
  const buttonText = children || /*#__PURE__*/_jsx(FormattedMessage, {
    message: "purchaseMotions.buttons.signup"
  });
  return /*#__PURE__*/_jsx(Button, Object.assign({
    "data-test-id": dataTestId !== null && dataTestId !== void 0 ? dataTestId : 'signup-button',
    "data-selenium-id": dataSeleniumId,
    use: "primary"
  }, uiButtonProps, {
    href: signupUrl || undefined,
    onClick: handleClick,
    disabled: !signupUrl,
    children: buttonText
  }));
};
export const SignupButton = props => /*#__PURE__*/_jsx(ErrorBoundary, {
  boundaryName: ErrorBoundaryNames.SIGNUP_BUTTON,
  children: /*#__PURE__*/_jsx(SignupButtonBase, Object.assign({}, props))
});